import { FieldValues, useController, UseControllerProps } from "react-hook-form";
import DropDown from "./Dropdown";

type Props<T extends FieldValues> = UseControllerProps<T> & { label: string; reasons?: string[] };

export default function ReasonDropdown<T extends FieldValues>({ control, name, rules, label, reasons = [] }: Props<T>) {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({ control, name, rules });

  return (
    <DropDown
      label={label}
      setValue={onChange}
      value={value}
      list={reasons.map((label: string) => ({ label, value: label }))}
      error={error}
      testID="ReasonDropdown"
    />
  );
}
